<template>
  <div>
    <label
      class="attribute-listing-filters-attribute-entry-label"
      :class="isHexGroup(group.attributeDisplayType) ? 'hex' : ''"
      :style="isHexGroup(group.attributeDisplayType) ? 'background:'+ entry.attributeDisplayValue : ''"
    >
      <input
        class="attribute-listing-filters-attribute-entry-input"
        type="checkbox"
        :checked="isFilterUsed(group, entry)"
        :style="isHexGroup(group.attributeDisplayType) ? 'display: none' : ''"
        @click='filteringLocationManage(group, entry)'
      >
      <a
        class="attribute-listing-filters-attribute-entry-link"
        :href="`${builtQueryString}#list-page-start`"
        :title="entryDisplayValue(group, entry)"
        rel="nofollow"
      >
        <span
          v-if="group.attributeDisplayType !== 'hex-color'"
          class="attribute-listing-filters-attribute-entry-name"
        >
          {{ entryDisplayValue(group, entry, { trim: true }) }}
        </span>
        <i v-if="isHexGroup(group.attributeDisplayType)"
           :class="isFilterUsed(group, entry) ? 'lni lni-checkmark' : 'lni'">
        </i>
      </a>
    </label>
  </div>
</template>

<script>

import AttributeListingFiltersMixin from '../Mixins/AttributeListingFiltersMixin'

export default {
  name: 'EntryFilter',
  mixins: [AttributeListingFiltersMixin],
  props: {
    group: {
      attributeDisplayType: '',
      attributeGroupId: '',
      attributeGroupName: null,
      attributeGroupStep: 0,
      attributeGroupDisplayPosition: 0,
      attributes: []
    },
    entry: {
      attributeActive: '',
      attributeDisplayValue: '',
      attributeId: '',
      attributeName: '',
      attributeOrder: ''
    }
  },
  computed: {
    builtQueryString () {
      return this.filteringManage(this.group, this.entry)
    }
  },
  methods: {
    isHexGroup (displayType) {
      return displayType === 'hex-color'
    }
  }
}
</script>
